import { ReactNode, useEffect } from 'react';
import { FluentProvider } from '@fluentui/react-components';
import { lightTheme } from '../theme/brandTheme';

/**
 * v2 : mode unique LIGHT. Dark mode retire (theme EU compliance ne se prete
 * pas a un mode sombre - les nuances bleu UE + or etoile perdraient leur sens).
 *
 * Wrap l'app dans FluentProvider avec light theme et propage la couleur de
 * fond au <body> + <html> (evite le bord blanc au boot).
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const bg = lightTheme.colorNeutralBackground1;
    document.body.style.backgroundColor          = bg;
    document.documentElement.style.backgroundColor = bg;
    document.documentElement.style.colorScheme   = 'light';
  }, []);

  return (
    <FluentProvider theme={lightTheme} style={{ minHeight: '100vh' }}>
      {children}
    </FluentProvider>
  );
}
